import React, { useEffect, useState } from 'react';
import {
  Await,
  useLoaderData,
} from '@tanstack/react-router';

import MemorySharing from '../components/MemorySharing';
import MemoryButtons from '../components/Memory/Buttons';
import MemoryType from '../components/Memory/Type';
import MemoryMeta from '../components/Memory/Meta';
import MemoryAssets from '../components/Memory/Assets';
import MemoryContent from '../components/Memory/Content';
import MemoryReactions from '../components/Memory/Reactions';
import MemoryComments from '../components/Memory/Comments';
import MemoryStats from '../components/Memory/Stats';
import MemoryTimeline from '../components/Memory/Timeline';
import Notices from '../components/Notices';
import Loading from '../components/Loading';

import type { Comment } from '../types/comment';
import type { Timeline } from '../types/timeline';

import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/callout/callout.js';

const MemoryView: React.FC = () => {
  const [currentTimeline, setCurrentTimeline] = useState<Timeline | null>(null);
  const {
    memory,
    comments,
    timeline,
  } = useLoaderData({ strict: false });

  useEffect(() => {
    setCurrentTimeline(timeline);
  }, [timeline]);

  return (
    <div className="container memory-view-container">
      <div className="wa-flank wa-flank:end wa-gap-0 wa-align-items-start" style={{ '--flank-size': '450px' } as React.CSSProperties}>
        <div className="memory-view wa-stack">
          <div className="memory-view-inner wa-stack">
            <Notices />
            <MemoryType memory={memory} />
            {memory.title && (
              <h1>{memory.title}</h1>
            )}
            {memory.variant === 'memory' && (
              <MemoryMeta memory={memory} />
            )}
            <MemoryAssets memory={memory} />
            <MemoryContent memory={memory} />
            <MemoryReactions memory={memory} readOnly />
            <Await promise={comments as Promise<Comment[]>} fallback={<Loading />}>
              {(comments) => (
                <MemoryComments
                  memoryId={memory.id}
                  comments={comments}
                  commentsCount={memory.comments_count}
                  commentsAllowed={memory.allow_comments}
                  readOnly
                />
              )}
            </Await>
            <MemoryStats memory={memory} />
          </div>
        </div>
        <div className="memory-preview inner">
          <MemoryButtons memory={memory} page="view" />
          {currentTimeline && (
            <MemoryTimeline memory={memory} timeline={currentTimeline} />
          )}
          <MemorySharing memory={memory} />
        </div>
      </div>
    </div>
  );
}

export default MemoryView;
